import React, { useRef, useState, useEffect } from "react";
import styles from "./chat.module.css";
import { AiOutlineLeft, AiOutlineSend } from "react-icons/ai";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Message from "./Message";
import useChat from "./useChat";
import userAvatar from "../../../Assets/img/userProfile.png";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import axios from "axios";

const Chat = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { roomId } = useParams();
  const { messages, sendMessage, messagesState } = useChat(roomId);
  const [newMessage, setNewMessage] = useState("");
  const scrollToBottom = useRef(null);

  const scrollBottom = () => {
    scrollToBottom.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollBottom();
  });

  const handleNewMessageChange = (event) => {
    setNewMessage(event.target.value);
  };

  const handleSendMessage = async () => {
    if (!newMessage.trim()) return;

    const message = {
      user_id: location.state?.myUser?._id,
      conversation_id: roomId,
      message: newMessage,
    };

    try {
      await axios.post(
        `https://arianaapp.arianaapply.com/api/V1/chat/add-message`,
        message
      );
      sendMessage(newMessage);
      setNewMessage("");
    } catch (err) {
      console.log(err.response);
    }
  };

  return (
    <section className={styles.chatWrapper}>
      <div className={styles.chatApp}>
        <header className={styles.chatHeader}>
          <div className={styles.chatProfile}>
            <div className={styles.chatImage}>
              <img src={userAvatar} alt="avatar" />
            </div>
            <div className={styles.chatName}>
              <h4>{location.state?.receiver}</h4>
            </div>
          </div>

          <div className={styles.backButton} onClick={() => navigate(-1)}>
            <AiOutlineLeft size={32} color="#fff" />
          </div>
        </header>

        <div className={styles.chatBody}>
          {messagesState === 0 ? (
            <div className="spinner">
              <Loader
                type="TailSpin"
                color="rgb(236, 177, 28)"
                height={80}
                width={80}
              />
            </div>
          ) : messagesState === 2 ? (
            <p className={styles.emptyList}>
              در حال حاضر گفتگویی برای شما وجود ندارد
            </p>
          ) : (
            messages.map((msg, i) => (
              <React.Fragment key={i}>
                <Message
                  message={msg}
                  own={
                    msg.user_id?.[0] === location.state?.myUser?._id
                      ? true
                      : false
                  }
                />
                <div ref={scrollToBottom} />
              </React.Fragment>
            ))
          )}
        </div>

        <div className={styles.chatFooter}>
          <input
            placeholder="پیام خود را تایپ کنید..."
            name="message"
            value={newMessage}
            onChange={handleNewMessageChange}
            onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
          />
          <button onClick={handleSendMessage}>
            <AiOutlineSend
              size={32}
              color="#251d23"
              className={styles.sentIcon}
            />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Chat;